module.exports = __webpack_public_path__ + "img/Uploadrecording.063e1d13.svg";